import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
// import { contentSpacingStyles } from "@tecumseh/theme/mixins";
// import breakpointValuesMediaQueries from "@tecumseh/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export default {
    fontFamilyImportUrl:
        "https://fonts.googleapis.com/css2?family=Barlow:wght@300;500&family=Dosis:wght@500;600&family=Montserrat:wght@300;400;500&display=swap",
    body: {
        fontFamily: "Montserrat",
        lineHeight: TYPOGRAPHY.lineHeight.base,
        size: TYPOGRAPHY.size.base,
        weight: TYPOGRAPHY.weight.base,
    },
    legend: {
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        transform: "uppercase",
        css: css`
            line-height: 16px;
        `,
    },
    p: {
        fontFamily: "Montserrat",
        size: TYPOGRAPHY.size.large,
        weight: TYPOGRAPHY.weight.base,
        css: css``,
    },
    h1: {
        // size: 40,
        weight: TYPOGRAPHY.weight.black,
        color: COLORS.black,
        fontFamily: "Barlow",
        css: css`
            line-height: 64px;
        `,
    },
    h2: {
        // size: 28,
        weight: TYPOGRAPHY.weight.black,
        color: COLORS.black,
        fontFamily: "Barlow",

        css: css`
            line-height: 48px;
        `,
    },
    h3: {
        // size: 18,
        weight: TYPOGRAPHY.weight.bold,
        color: COLORS.black,
        fontFamily: "Barlow",

        css: css`
            line-height: 40px;
        `,
    },
    h4: {
        // size: 24,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        fontFamily: "Barlow",

        css: css`
            line-height: 32px;
        `,
    },
    h5: {
        // size: 18,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        fontFamily: "Barlow",

        css: css`
            line-height: 24px;
        `,
    },
    h6: {
        // size: 16,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        fontFamily: "Barlow",

        css: css`
            line-height: 24px;
        `,
    },
    headerPrimary: {
        transform: "none",
        size: 29,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        fontFamily: "Dosis",

        css: css``,
    },
    headerSecondary: {
        transform: "none",
        size: 22,
        fontFamily: "Dosis",
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css``,
    },
    headerTertiary: {
        transform: "uppercase",
        size: 14,
        weight: TYPOGRAPHY.weight.baseBold,
        lineHeight: 1.2,
        letterSpacing: 0.6,
        fontFamily: "Dosis",
        css: css`
            font-style: normal;
        `,
    },
};
